var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEncerrar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1064_1340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 4C12.8244 4 10.6977 4.64513 8.88873 5.85382C7.07979 7.06252 5.6699 8.78048 4.83734 10.7905C4.00478 12.8005 3.78693 15.0122 4.21136 17.146C4.6358 19.2798 5.68342 21.2398 7.2218 22.7782C8.76018 24.3166 10.7202 25.3642 12.854 25.7886C14.9878 26.2131 17.1995 25.9952 19.2095 25.1627C21.2195 24.3301 22.9375 22.9202 24.1462 21.1113C25.3549 19.3023 26 17.1756 26 15C26 12.0826 24.8411 9.2847 22.7782 7.2218C20.7153 5.1589 17.9174 4 15 4ZM20 18.54L18.54 20L15 16.41L11.46 20L10.05 18.59L13.59 15.05L10.05 11.51L11.46 10.1L15 13.64L18.54 10.1L19.95 11.51L16.41 15L20 18.54Z",
    fill: "#053779"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 30C12.0333 30 9.1332 29.1203 6.66646 27.4721C4.19973 25.8238 2.27712 23.4811 1.14181 20.7403C0.00649226 17.9994 -0.290548 14.9834 0.28823 12.0737C0.867008 9.16398 2.29561 6.49118 4.39339 4.39339C6.49118 2.29561 9.16398 0.867008 12.0737 0.28823C14.9834 -0.290548 17.9994 0.00649226 20.7403 1.14181C23.4811 2.27712 25.8238 4.19973 27.4721 6.66646C29.1203 9.1332 30 12.0333 30 15C30 18.9783 28.4197 22.7936 25.6067 25.6067C22.7936 28.4197 18.9783 30 15 30ZM15 2.00002C12.4289 2.00002 9.91545 2.76248 7.77761 4.19094C5.63977 5.6194 3.97352 7.64967 2.98958 10.0251C2.00565 12.4005 1.74823 15.0145 2.24984 17.5362C2.75145 20.058 3.98956 22.3743 5.80764 24.1924C7.62572 26.0105 9.94207 27.2486 12.4638 27.7502C14.9856 28.2518 17.5995 27.9944 19.9749 27.0105C22.3504 26.0265 24.3806 24.3603 25.8091 22.2224C27.2376 20.0846 28 17.5712 28 15C28 11.5522 26.6304 8.24561 24.1924 5.80764C21.7544 3.36967 18.4478 2.00002 15 2.00002Z",
    fill: "#1680E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1064_1340"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEncerrar);
export default __webpack_public_path__ + "static/media/encerrar.c9b186d1d5bfb98f42ea50472e74898c.svg";
export { ForwardRef as ReactComponent };